import React from 'react';
import { Card, CardContent, CardHeader, Divider, Grid } from '@material-ui/core';
import { FieldLabel, FieldText } from '../../components/Field';

function useFormValues(form, selector) {
    const [selected, setSelected] = React.useState(() => selector(form.values));
    React.useEffect(() => {
        const unsub = form.subscribe(() => {
            setSelected(selector(form.values));
        });
        return unsub;
    }, [form, selector]);
    return selected;
}

export function Product({ form }) {
    const { ModelCode, ProductMarketingCode, SerialNumber, ProductionYear, ProductionPeriod } =
        useFormValues(form, v => ({
            ModelCode: v.ModelCode,
            ProductMarketingCode: v.ProductMarketingCode,
            SerialNumber: v.SerialNumber,
            ProductionYear: v.ProductionYear,
            ProductionPeriod: v.ProductionPeriod
        }));
    return (
        <Card>
            <CardHeader title="Product Detail" />
            <Divider />
            <CardContent>
                <Grid container>
                    <Grid item xs={12} sm={6} lg={6}>
                        <FieldLabel>Product</FieldLabel>
                        <FieldText>
                            {ModelCode} - {ProductMarketingCode}
                        </FieldText>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6}>
                        <FieldLabel>Serial Number</FieldLabel>
                        <FieldText>{SerialNumber || 'Not specified'}</FieldText>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6}>
                        <FieldLabel>Production Year</FieldLabel>
                        <FieldText>{ProductionYear || 'Not specified'}</FieldText>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6}>
                        <FieldLabel>Product Period</FieldLabel>
                        <FieldText>{ProductionPeriod || 'Not specified'}</FieldText>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}
